import useDevice from 'hooks/DesktopDevice.hook';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { RootState } from 'store/store';
import { BoxOverflow, Grid, Typography } from 'styles';
import Box from 'styles/box/Box';
import Stack from 'styles/stack/Stack';
import { PATHNAMES } from 'utils/constants';
import { useTranslation } from 'utils/translations';
import AdditionalDetails from './PaymentDetailsSections/AdditionalDetails.component';
import DownloadButton from './PaymentDetailsSections/DownloadButton.component';
import PaymentFrom from './PaymentDetailsSections/PaymentFrom.component';
import PaymentTo from './PaymentDetailsSections/PaymentTo.component';
import Ticket from './PaymentDetailsSections/Ticket.component';

const PaymentDetails = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const param = useParams();
	const location = useLocation();
	const { isDesktop } = useDevice();

	const { errorCode, errorMessage } = useSelector(
		(store: RootState) => store.payment,
	);
	const { profile } = useSelector((store: RootState) => store.user);
	const splittedLocation = location.pathname.split('/');

	if (errorCode !== 0) {
		return (
			<Typography variant="bodyLink">{`Payment ${param.id} ${errorMessage} for provider ${profile?.location}`}</Typography>
		);
	}

	return (
		<BoxOverflow variant="y" sx={{ pr: '8px !important' }}>
			<Stack
				sx={{
					marginTop: isDesktop ? 1.875 : 1.25,
				}}
			>
				<Stack direction="column" justifyContent={'space-between'} pr={1}>
					<Box
						display={'flex'}
						flexDirection={'column'}
						flexWrap={'wrap'}
						justifyContent={'space-between'}
					>
						<Stack direction="column" gap="20px" width="100%">
							<Typography variant="body">
								{tClientLabels('payment.details.disclaimer')}
							</Typography>
							<Grid container columnSpacing={isDesktop ? 5 : 2.5} rowGap={5}>
								<Grid item lg={6} md={6} sm={6} pt={0}>
									<PaymentFrom />
								</Grid>
								<Grid item lg={6} md={6} sm={6}>
									<PaymentTo />
								</Grid>
								<Grid item sm={12}>
									<Grid container columnSpacing={isDesktop ? 5 : 2.5} rowGap={2.5}>
										<Grid item lg={6} md={6} sm={12}>
											<AdditionalDetails />
										</Grid>
										<Grid item lg={6} md={6} sm={12}>
											<Ticket />
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Stack>
					</Box>
				</Stack>
				<Stack
					display={'flex'}
					flexDirection={'row'}
					justifyContent={'flex-end'}
					pt={isDesktop ? 5 : 2.5}
					pb={isDesktop ? 5 : 2.5}
					pr={1}
				>
					<DownloadButton
						type={
							splittedLocation.includes(PATHNAMES.ASSESSMENT_FEE_INVOICE)
								? 'claim'
								: 'group'
						}
					/>
				</Stack>
			</Stack>
		</BoxOverflow>
	);
};

export default PaymentDetails;
